import { useCompanyDetailQuery } from "Company/Api/Query/useCompanyDetailQuery";
import { EditFormWidget } from "Company/Components/Widgets/EditFormWidget";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PageContainer } from "Shared/Components/Container";
import { Loading } from "Shared/Components/Loading/Loading";
import { Stack } from "@mui/material";
import { useParams } from "react-router";
import { BankDetailWidget } from "../Modules/BankDetail/Widgets/BankDetailWidget";

export const CompanyDetailPage = () => {
	const { t } = useResource();
	const companyResource = Resources.base.company;
	const { id } = useParams();
	const paramsCompanyId = id ? Number(id) : undefined;
	const { data: company, isLoading } = useCompanyDetailQuery(paramsCompanyId);

	return (
		<PageContainer
			title={t(companyResource.shared.editCompany)}
			description="Company management"
		>
			<Stack spacing={2} direction="column" alignItems="center">
				{isLoading && <Loading />}
				{company && <EditFormWidget company={company} />}
				{company?.id && <BankDetailWidget companyId={company.id} />}
			</Stack>
		</PageContainer>
	);
};
